import type { FaireProductEntity } from "../../entity_types/product";

export const p_8cugbkc95q: FaireProductEntity = {
  token: "p_8cugbkc95q",
  type: "product",
  name: "Crown Point Organic Espresso, 12 oz - Organic",
  brandToken: "b_3angyj4q6y",
  brandName: "Sightglass Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/45fe8e2c1592c0134f6151cfa52d0038ae698f15b48808d02bf466f54ef88ba4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9bac7760c4adca906f970838ad517c6496cf5db0396c9d565b649c75715fb558.png",
    "https://cdn.faire.com/fastly/ca8b01d5d93fe920b18da5054645450e7cc243bccb09f4935f81fa2a32a058c6.png",
    "https://cdn.faire.com/fastly/443a70ba743c00b079f7e372b3cc355b79a72c0c0266c0829510f4a5b1cf40d5.jpeg",
    "https://cdn.faire.com/fastly/e136cb9c51e8bf15ed806bbf4ecc8f46f7650e750620a3d644182d77c7023bf9.jpeg",
    "https://cdn.faire.com/fastly/9ccf66ccd4b10f0cd7dd2ce43179cc5dd5c882b40a89225c905ea3b3dc126352.jpeg"
  ],
  priceDollars: 12.15,
  description: "Crown Point Espresso // This espresso roast was crafted to pair perfectly with milk, and offer a blend for all types of coffee drinkers. This blend has a base of seasonally rotating Central and South American coffees and showcases a lively, full-bodied sweetness, clean candy-like fruit flavors, and an elegant lingering finish.\nCCOF Certified Organic\nTaste Notes // Raspberry, Chocolate, Butterscotch\nRoast Profile // Espresso\nRecommended Brew Method // Espresso, French Press, Aeropress\nShelf Life // All our whole bean coffees are roasted fresh to order and stamped with the roast date. We encourage selling the coffee within 60 days of the printed date for optimal freshness and flavor. If you have questions about freshness or how to brew this coffee, send us a note or email [redacted-email]!",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:44.668Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
